module.exports = __webpack_public_path__ + "static/media/13 - qCo0Jbj.e58d7673.jpg";